// #773 — Series Discovery replies must not be empty bubbles.
// Same words as backend/services/series_discovery_reply.py.

export const EMPTY_SERIES_DISCOVERY_REPLY =
  "I couldn't put that into words just now. Ask again, or say a bit more about the series, and I'll try again.";

export function isSeriesDiscoveryChat({ projectId, storyId } = {}) {
  return Boolean(projectId) && !storyId;
}

export function seriesDiscoveryReplyText(content) {
  const cleaned = (content == null ? '' : String(content)).trim();
  return cleaned || EMPTY_SERIES_DISCOVERY_REPLY;
}
